var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14ZM8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 -3.12974e-07 8 -6.99382e-07C3.58 -1.08579e-06 1.08579e-06 3.58 6.99382e-07 8C3.12974e-07 12.42 3.58 16 8 16ZM9 11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11L7 8C7 7.44771 7.44772 7 8 7C8.55229 7 9 7.44771 9 8L9 11ZM8 6C8.55229 6 9 5.55228 9 5C9 4.44771 8.55229 4 8 4C7.44772 4 7 4.44771 7 5C7 5.55228 7.44772 6 8 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9d10f5ba260914517de8d9a262aaf451.svg";
export { ForwardRef as ReactComponent };